import { Colors } from '@sigma-frontend-libs/commons'

import { buttonModes, components, popperPlacements } from '@/utils'

import button from '@/components/button'
import { className } from '@/components/services/documentation/utils'

function renderHeading(h, heading) {
  if (heading) {
    return h(
      'li',
      {
        attrs: { id: `${className}-toc-list-level-${heading.slug}` },
        class: {
          [`${className}-toc-list-level ${className}-toc-list-level--${heading.level} text-overflow`]: true,
          [`${className}-toc-list-level--arrow`]: Array.isArray(heading.childs) && heading.childs.length > 0
        }
      },
      [
        h(
          'router-link',
          {
            props: {
              to: {
                name: `${className}.file`,
                params: { file: this.$route.params.file },
                query: { id: heading.slug }
              }
            }
          },
          heading.title
        ),

        renderHeadingChilds.call(this, h, heading.childs)
      ]
    )
  }
}

function renderHeadings(h, heading) {
  if (heading) {
    return h(
      'ul',
      {
        class: `${className}-toc-list ${className}-toc-list--sub`
      },
      [ renderHeading.call(this, h, heading) ]
    )
  }
}

function renderHeadingChilds(h, childs) {
  if (Array.isArray(childs) && childs.length > 0) {
    return childs.map(heading => {
      return renderHeadings.call(this, h, heading)
    })
  }
}

function renderListOfHeadings(h, file) {
  if (Array.isArray(this.toc) && this.toc.length > 0 && this.$route.params.file === file) {
    return this.toc.map(heading => {
      return renderHeadings.call(this, h, heading)
    })
  }
}

function renderFiles(h, category, files) {
  if (Array.isArray(files) && files.length > 0) {
    return h(
      'ul',
      {
        class: `${className}-toc-list ${className}-toc-list--sub`
      },
      [
        files.map(file => {
          return h(
            'li',
            {
              attrs: { id: `${className}-category-${category}-file-${file}` },
              class: `${className}-toc-list-level ${className}-toc-list-level--file ${className}-toc-list-level--arrow text-overflow`
            },
            [
              h(
                'router-link',
                {
                  props: {
                    to: {
                      name: `${className}.file`,
                      params: {
                        category,
                        file
                      }
                    }
                  }
                },
                this.getTranslate(`${className}.files.${file}`)
              ),

              renderListOfHeadings.call(this, h, file)
            ]
          )
        })
      ]
    )
  }
}
function renderLevels(h) {
  return this.levels.map(({ category, files }) => {
    return [
      h(
        'h3',
        {
          class: `${className}-toc-list-title`
        },
        this.getTranslate(`${className}.categories.${category}`)
      ),

      renderFiles.call(this, h, category, files)
    ]
  })
}
function renderToc(h) {
  return h(
    'div',
    {
      class: `${className}-toc-list`
    },
    [ renderLevels.call(this, h) ]
  )
}

function renderMenuActivator(h) {
  return h(
    'div',
    {
      class: `${className}-toc__button`,
      slot: 'activator'
    },
    [
      h(
        button,
        {
          props: {
            label: this.getTranslate(`${className}.toc`),
            mode: buttonModes.flat,
            color: Colors.primary,
            fullWidth: true
          }
        }
      )
    ]
  )
}
function renderMenuContent(h) {
  return h(
    'div',
    {
      class: `${className}-toc__menu`
    },
    [ renderToc.call(this, h) ]
  )
}
function renderMenu(h) {
  return h(
    components.menu,
    {
      props: {
        rounded: true,
        offsetDistance: 8,
        placement: popperPlacements.bottom,
        closeOnContentClick: false,
        sameWidth: true
      }
    },
    [
      renderMenuActivator.call(this, h),
      renderMenuContent.call(this, h)
    ]
  )
}

function renderContentByViewport(h) {
  if (this.viewport.size.width > 1380) {
    return renderToc.call(this, h)
  }

  return renderMenu.call(this, h)
}

export default function(h) {
  return h(
    'div',
    {
      class: `${className}-toc`
    },
    [ renderContentByViewport.call(this, h) ]
  )
}
